import * as read_more from "./read_more";
import { tooltip } from "./tooltip.mjs";
/**
 * storage -- storage for urls of the "current" state, the associated data feeds necessary, and previously gotten data
 *
 */
let storage = {
	urls: {
		current: {
			prefix: "countries",
			countries: null,
			country: null,
			region: null,
			subregion: null,
		},
		data: {
			prefix: "data/countries",
			countries: null,
			country: null,
			region: null,
			subregion: null,
		}
	},
	data: {
		countries: {},
		country: [],
		region: [],
		subregion: [],
	},
};
let elements = {
	controls: {
		$country: $("#country"),
		$region: $("#region"),
		$subregion: $("#subregion"),
		$brands: $("#brands"),
		$map_toggle: $(".countries__map_toggle"),
	},
	content: {
		$map: $(".countries__map"),
		$title: $(".countries__title"),
		$text: $(".countries__desc"),
		$container: $("body"),
	}
}
/**
 * set_urls -- parses the window location and creates necessary urls for each component
 *
 * the current country, region, and subregion are paths to their associated processwire page
 * the data country, region, and subregion are the paths necessary for the data feed for those pages
 *
 * eg
 * current: /countries/foo/bar/baz/
 * data: /data/foo/bar/baz/
 *
 */
function set_urls() {
	let [, countries, country, region, subregion,] = window.location.pathname.split("/");
	let current = storage.urls.current;
	current.countries = countries ? `/${countries}/` : null;
	current.country = country ? `/${countries}/${country}/` : null;
	current.region = region ? `/${countries}/${country}/${region}/` : null;
	current.subregion = subregion ? `/${countries}/${country}/${region}/${subregion}/` : null;
	let data = storage.urls.data;
	data.countries = current.countries ? current.countries.replace(current.prefix, data.prefix) : null;
	data.country = current.country ? current.country.replace(current.prefix, data.prefix) : null;
	data.region = current.region ? current.region.replace(current.prefix, data.prefix) : null;
	data.subregion = current.subregion ? current.subregion.replace(current.prefix, data.prefix) : null;
}
/**
 * determine_view -- are we on a country, region, or subregion state?
 *
 */
function determine_view() {
	let current = storage.urls.current;
	if (current.subregion) {
		view.prepare.subregion();
	}
	else if (current.region) {
		view.prepare.region();
	}
	else if (current.country) {
		view.prepare.country();
	}
	else {
		view.prepare.countries();
	}
}
/**
 * data -- handle the checking for previously fetched data, getting new data, and storage of gotten data
 *
 * check: methods compare where we are with what we have stored. do we need more data?
 * get: methods fire when we need the data. use stored parsed urls for the data feeds for our current state
 * store: fired as callback for get methods -- we have data so store it.
 *
 */
let data = {
	check: {
		countries: function () {
			if (!Object.keys(storage.data.countries).length) {
				return data.get.countries();
			}
		},
		country: function () {
			if (!storage.data.country[storage.urls.current.country]) {
				return data.get.country();
			}
		},
		region: function () {
			if (!storage.data.region[storage.urls.current.region]) {
				return data.get.region();
			}
		},
		subregion: function () {
			if (!storage.data.subregion[storage.urls.current.subregion]) {
				return data.get.subregion();
			}
		},
	},
	get: {
		countries: function () {
			return $.ajax({
				url: storage.urls.data.countries,
				success: data.store.countries
			});
		},
		country: function () {
			return $.ajax({
				url: storage.urls.data.country,
				success: data.store.country
			});
		},
		region: function () {
			return $.ajax({
				url: storage.urls.data.region,
				success: data.store.region
			});
		},
		subregion: function () {
			return $.ajax({
				url: storage.urls.data.subregion,
				success: data.store.subregion
			});
		}
	},
	store: {
		countries: function (data) {
			storage.data.countries = data;
		},
		country: function (data) {
			storage.data.country[data.url] = data;
		},
		region: function (data) {
			storage.data.region[data.url] = data;
		},
		subregion: function (data) {
			storage.data.subregion[data.url] = data;
		},
	}
};
/**
 * view -- handle preparation of all the needs for this view, then fire it
 *
 * the big timing trick is the $.when jquery method which allows us
 * to draw the view once all of the ajax methods have returned data to be stored
 *
 */
let view = {
	prepare: {
		countries: function () {
			$.when(data.check.countries())
				.done(view.draw.countries);
		},
		country: function () {
			$.when(data.check.countries(), data.check.country())
				.done(view.draw.country);
		},
		region: function () {
			$.when(data.check.countries(), data.check.country(), data.check.region())
				.done(view.draw.region);
		},
		subregion: function () {
			$.when(data.check.countries(), data.check.country(), data.check.region(), data.check.subregion())
				.done(view.draw.subregion);
		}
	},
	draw: {
		countries: function () {
			elements.content.$container.attr("data-view", "countries");
			let countries = storage.data.countries;
			update_select(
				elements.controls.$country,
				countries.regions
			);
			elements.controls.$region.hide();
			elements.controls.$subregion.hide();
			elements.controls.$brands.hide();
			elements.controls.$map_toggle.hide();
			handle_map(
				countries.map,
				countries.regions
			);
			// text: country title
			elements.content.$title.html("");
			// text: country description
			elements.content.$text.html("");
		},
		country: function () {
			elements.content.$container.attr("data-view", "country");
			let countries = storage.data.countries;
			let country = storage.data.country[storage.urls.current.country];
			// map: country map placed
			handle_map(
				country.map,
				country.regions
			);
			// map: region handlers and classing
			// select: country
			update_select(
				elements.controls.$country,
				countries.regions,
				country.url
			);
			// select: regions
			update_select(
				elements.controls.$region,
				country.regions,
			);
			// select: subregion
			elements.controls.$subregion.hide();
			// select: brands
			update_select(
				elements.controls.$brands,
				country.brands
			);
			// text: country title
			elements.content.$title.html(country.title);
			// text: country description
			elements.content.$text.html(country.description);
			read_more.init();
			// map toggle button
			elements.controls.$map_toggle.hide();
		},
		region: function () {
			elements.content.$container.attr("data-view", "region");
			let countries = storage.data.countries;
			let country = storage.data.country[storage.urls.current.country];
			let region = storage.data.region[storage.urls.current.region];
			// select: country
			update_select(
				elements.controls.$country,
				countries.regions,
				country.url
			);
			// select: regions
			update_select(
				elements.controls.$region,
				country.regions,
				region.url
			);
			// select: subregion
			update_select(
				elements.controls.$subregion,
				region.subregions
			);
			// map: country map placed
			handle_map(
				country.map,
				country.regions,
				region.name
			);
			// map: region current class
			$("#" + region.name, elements.content.$map).addClass("is_active");
			// map: region handlers and classing
			// select: region brands
			update_select(
				elements.controls.$brands,
				region.brands
			);
			// select: subregions
			// text: region title
			elements.content.$title.html(region.title);
			// text: region description
			elements.content.$text.html(region.description);
			read_more.init();
			// map toggle button
			elements.controls.$map_toggle.removeClass("is_region").show();
		},
		subregion: function () {
			elements.content.$container.attr("data-view", "subregion");
			let countries = storage.data.countries;
			let country = storage.data.country[storage.urls.current.country];
			let region = storage.data.region[storage.urls.current.region];
			let subregion = storage.data.subregion[storage.urls.current.subregion];
			// select: country
			update_select(
				elements.controls.$country,
				countries.regions,
				country.url
			);
			// select: regions
			update_select(
				elements.controls.$region,
				country.regions,
				region.url
			);
			// select: subregion
			update_select(
				elements.controls.$subregion,
				region.subregions,
				subregion.url
			);
			// map: region map placed
			elements.content.$map.html(region.map);
			handle_map(
				region.map,
				region.subregions,
				subregion.name
			);
			// map: subregion current class
			$("#" + subregion.name, elements.content.$map).addClass("is_active");
			// map: subregion handlers and classing
			// text: subregion title
			elements.content.$title.html(subregion.title);
			// text: subregion description
			elements.content.$text.html(subregion.description);
			read_more.init();
			// select: subregions brands
			update_select(
				elements.controls.$brands,
				subregion.brands
			);
			// map toggle button
			elements.controls.$map_toggle.addClass("is_region").show();
		}
	},
}
function handle_map_toggle() {
	elements.controls.$map_toggle.show().on("click", function (e) {
		let country = storage.data.country[storage.urls.current.country];
		let region = storage.data.region[storage.urls.current.region];
		let subregion = storage.data.subregion[storage.urls.current.subregion];
		if ($(this).hasClass("is_region")) {
			$(this).removeClass("is_region");
			handle_map(
				country.map,
				country.regions,
				region.name
			);
		} else {
			$(this).addClass("is_region");
			if (typeof subregion == "undefined") {
				handle_map(
					region.map,
					region.subregions
				);
			} else {
				handle_map(
					region.map,
					region.subregions,
					subregion.name
				);
			}
		}
	});

}
function update_select($select = $(), data = null, value = null,) {
	const has_data = data != null;
	const has_value = value != null;
	if (has_data) {
		// clear any existing options leaving default
		$select.children().not(":first-child").remove();
		data.forEach(function populate_options(data) {
			let $option = $("<option/>");
			$option.text(data.title);
			$option.attr("value", data.url);
			$select.append($option).show();
		});
	}
	if (has_value) {
		$select.val(value);
	}
	if (has_data && data.length == 0) {
		$select.hide();
	}
}
function handle_map(base_html = null, areas_array = null, current_name = null) {
	let $map = $(base_html);
	let $regions = $("#regions", $map);
	areas_array.forEach(function class_areas(area) {
		let $target = $("#" + area.name, $map);
		$target.addClass("has_wines");
		$target.on("click", function map_click() {
			let t = document.title;
			let postfix = t.slice(t.indexOf(" |"), t.length);
			document.title = area.title + postfix;
			window.history.pushState(null, null, area.url);
			run();
		});
		$target.data("area", area);
		tooltip($target);
	});
	if (current_name) {
		let $current = $("#" + current_name, $map);
		$current.addClass("is_current");
		// make it the foremost top layer so it shows in full
		$current.appendTo($current.parent());
	}

	let $nowines = $regions.children().not(".has_wines");
	$regions.prepend($nowines);
	elements.content.$map.html($map);
}
function set_select_handlers() {
	// brand selected
	elements.controls.$brands.on("change", function jump_to_brand() {
		window.location = $(this).val();
	});
	// location change
	$(".countries__location_controls select").on("change", function update_location() {
		// default option selected, not a specific country/reg/sub
		if (!$(this).val()) {
			// if is first select box "country"
			if (!$(this).prev().length) {
				set_title_and_history($(this));
				run();
			} else {
				$(this).prev().trigger("change");
			}
			return;
		}
		set_title_and_history($(this));
		run();
	});
	// back button
	window.onpopstate = run;
}
function set_title_and_history($ele) {
	let t = document.title;
	let postfix = t.slice(t.indexOf(" |"), t.length);
	document.title = $(":selected", $ele).text() + postfix;
	window.history.pushState(null, null, $ele.val());
}

function set_click_handlers() {
	$(".countries__all a").on("click", function (e) {
		e.preventDefault();
		window.history.pushState(null, null, $(this).attr("href"));
		run();
	});
}
function run() {
	set_urls();
	determine_view();
}
export function init() {
	if (!$(".countries").length) return;
	set_select_handlers();
	set_click_handlers();
	handle_map_toggle();
	run();
}
